import type { ChargeEvent, PowerFlow } from '../api/client/ders'

// Canonical mapping between the snapshot's PowerFlow vocabulary and the legacy ChargeEvent
// vocabulary still used on /transactions and by the battery-status formatter.
export const powerFlowToChargeEvent: Record<PowerFlow, ChargeEvent> = {
  IMPORT: 'CHARGING',
  EXPORT: 'DISCHARGING',
  IDLE: 'IDLE',
  UNKNOWN: 'UNKNOWN'
}

export type GeneratorStatus = 'RUNNING' | 'IDLE' | 'UNKNOWN'

// IMPORT collapses to IDLE: a non-running generator still draws a small amount of
// power (e.g. from a local battery) to stay on, which the polaroid reports as a
// negative activePower → powerFlow=IMPORT. From the operator's perspective the
// generator is idle, not actively producing power.
export function powerFlowToGeneratorStatus(flow?: PowerFlow): GeneratorStatus {
  switch (flow) {
    case 'EXPORT':
      return 'RUNNING'
    case 'IDLE':
    case 'IMPORT':
      return 'IDLE'
    default:
      return 'UNKNOWN'
  }
}

export type SolarArrayStatus = 'PRODUCING' | 'IDLE' | 'UNKNOWN'

// IMPORT collapses to IDLE: a non-producing array's inverter still draws a small
// tare/keep-alive power (e.g. overnight), which the polaroid reports as a
// negative activePower → powerFlow=IMPORT. From the operator's perspective the
// array is idle, not meaningfully consuming.
export function powerFlowToSolarArrayStatus(flow?: PowerFlow): SolarArrayStatus {
  switch (flow) {
    case 'EXPORT':
      return 'PRODUCING'
    case 'IDLE':
    case 'IMPORT':
      return 'IDLE'
    default:
      return 'UNKNOWN'
  }
}

export default function chargeEventMatchesPowerFlow(chargeEvent?: ChargeEvent, powerFlow?: PowerFlow) {
  return !!chargeEvent && !!powerFlow && powerFlowToChargeEvent[powerFlow] === chargeEvent
}
